export default {"src":"/_next/static/media/loading.fb2972c7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};